module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"patients_waiting":"1 patient waiting | {n} patients waiting","urgent_patients":"1 urgent patient | {n} urgent patients"}}')
  delete Component.options._Ctor
}
